module.exports = __webpack_public_path__ + "img/di-3-fang_01.f66fe860.jpg";